// document.addEventListener('DOMContentLoaded', () => {

function initUpcomingEvents() {
    document.querySelectorAll('.upcoming-events__wrapper').forEach(wrapper => {

        const arrowNodesE = wrapper.querySelector('.upcoming-events__arrow')
        const backNodesE = wrapper.querySelector('.upcoming-events__arrow-back')
        const eventNodes = wrapper.querySelector('.upcoming-events__list')
        console.log(arrowNodesE)
        console.log(backNodesE)
        console.log(eventNodes)
        // console.log(eventNodes.offsetWidth)
        // console.log(eventNodes.scrollWidth)

        // Check if the main elements actually exist before continuing
        if (!arrowNodesE || !backNodesE || !eventNodes) return;
        // console.log(!arrowNodesE || !backNodesE || !eventNodes)

        let scrolledP = 0

        arrowNodesE.addEventListener('click', () => {
            console.log('clicked next')
            if (eventNodes.offsetWidth < eventNodes.scrollWidth) {
                scrolledP += eventNodes.offsetWidth;
            }
            eventNodes.scroll({left: scrolledP, behavior: 'smooth'});

            if (scrolledP + eventNodes.offsetWidth >= eventNodes.scrollWidth) {
                arrowNodesE.classList.add('end');
            }
            if (scrolledP !== 0) {
                backNodesE.classList.remove('end');
            }
        });

        backNodesE.addEventListener('click', () => {
            console.log('clicked prev')
            if (scrolledP > 0) {
                scrolledP -= eventNodes.offsetWidth;
            }
            eventNodes.scroll({left: scrolledP, behavior: 'smooth'});

            if (scrolledP === 0) {
                backNodesE.classList.add('end');
            }
            arrowNodesE.classList.remove('end');
        });

        // Keyboard support (required and awesome!)
        arrowNodesE.addEventListener('keyup', e => {
            if (e.key === 'ArrowRight' || e.key === 'Enter') arrowNodesE.click();
        });
        backNodesE.addEventListener('keyup', e => {
            if (e.key === 'ArrowLeft' || e.key === 'Enter') backNodesE.click();
        });

        // let scrolledE = 0
        //
        // if (arrowNodesE.length > 0) {
        //     const arrowsE = Array.from(arrowNodesE)
        //     const backsE = Array.from(backNodesE)
        //     const events = Array.from(eventNodes)
        //
        //     arrowsE.map((arrow, key) => {
        //         arrow.addEventListener('click', () => {
        //             if (events[key].scrollLeft + events[key].offsetWidth < events[key].scrollWidth) {
        //                 scrolledE += 261
        //             }
        //
        //             events[key].scroll({
        //                 top: 0,
        //                 left: scrolledE,
        //                 behavior: 'smooth'
        //             })
        //         })
        //
        //         arrow.addEventListener('keypress', (e) => {
        //             if (e.charCode === 13) {
        //                 if (events[key].scrollLeft + events[key].offsetWidth < events[key].scrollWidth) {
        //                     scrolledE += 261
        //                 }
        //
        //                 events[key].scroll({
        //                     top: 0,
        //                     left: scrolledE,
        //                     behavior: 'smooth'
        //                 })
        //             }
        //         })
        //     })
        //
        //     backsE.map((arrow, key) => {
        //         arrow.addEventListener('click', () => {
        //             if (scrolledE > 0) {
        //                 scrolledE -= 261
        //             }
        //
        //             events[key].scroll({
        //                 top: 0,
        //                 left: scrolledE,
        //                 behavior: 'smooth'
        //             })
        //         })
        //
        //         arrow.addEventListener('keypress', (e) => {
        //             if (e.charCode === 13) {
        //                 if (scrolledE > 0) {
        //                     scrolledE -= 261
        //                 }
        //
        //                 events[key].scroll({
        //                     top: 0,
        //                     left: scrolledE,
        //                     behavior: 'smooth'
        //                 })
        //             }
        //         })
        //     })
        // }
    })
}
// })

// Make it globally available
window.initUpcomingEvents = initUpcomingEvents;

// Re-run whenever Sprig/htmx swaps in new content that might contain a player
document.body.addEventListener('htmx:afterSwap', (e) => {
    // Check if the swapped content (or its children) has the video element
    if (e.detail.target.matches('.upcoming-events__wrapper') || e.detail.target.querySelector('.upcoming-events__wrapper')) {
        initUpcomingEvents();
    }
});

// Also run once on initial load
document.addEventListener('DOMContentLoaded', initUpcomingEvents);